import { useEffect } from "react";
import { useDataAccumulatorForSingleOrder } from "../../../context/dataAccumulatorForSingleOrder";
import { getAllJCodesFromAuthOnFile } from "../utils/existingDocsToLs";

interface UseJCodeStatusCheckProps {
  setShouldDisableMarkAsComplete: (value: boolean) => void;
}

/**
 * Disables the "Mark as Completed" button when any J-code in the
 * auth-on-file data has a `not_available` status.
 *
 * Reads auth-on-file details from the Postgres-backed data-accumulator
 * context and re-evaluates whenever the data changes.
 *
 * @param props.setShouldDisableMarkAsComplete - Callback to toggle the button's disabled state
 */
export const useJCodeStatusCheck = ({
  setShouldDisableMarkAsComplete,
}: UseJCodeStatusCheckProps) => {
  const { authOnFileDetails } = useDataAccumulatorForSingleOrder();
  useEffect(() => {
    if (authOnFileDetails) {
      const jCodes = getAllJCodesFromAuthOnFile(
        authOnFileDetails?.auth_on_file,
      );

      if (jCodes && jCodes.length > 0) {
        let doesAnyJCodeHaveNotAvailableStatus = jCodes?.some(
          (jCode) => jCode.auth_status === "not_available",
        );
        if (doesAnyJCodeHaveNotAvailableStatus) {
          setShouldDisableMarkAsComplete(true);
        } else {
          setShouldDisableMarkAsComplete(false);
        }
      }
    }
  }, [authOnFileDetails, setShouldDisableMarkAsComplete]);
};
